import "../css/hero.css";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaCompass, FaMapMarkerAlt } from "react-icons/fa";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <div className="hero">
      <div className="hero-content">
        <span className="hero-kicker">
          <FaMapMarkerAlt /> Kimberley, Northern Cape
        </span>
        <h1>Discover Kimberley's Hidden Treasures</h1>
        <p>
          Where diamonds meet adventure - explore the heart of the Diamond City.
        </p>
        <div className="hero-actions">
          <button onClick={() => navigate("/planyourjourney")}>
            Start Your Journey <FaArrowRight />
          </button>
          <button className="hero-secondary" onClick={() => navigate("/walkingandhikingtours")}>
            Explore Places <FaCompass />
          </button>
        </div>
        <div className="hero-stats">
          <span>Stays</span>
          <span>Food</span>
          <span>Events</span>
          <span>Culture</span>
        </div>
      </div>
    </div>
  );
};

export default Hero;
